const LoadingScreen = () => (
  <div className="spinner">
    <div className="loadingLogo" />
  </div>
);

export default LoadingScreen;
